<template>
  
  <div class="pc_only">
    <h2 class="kojin-title"><slot>タイトル</slot></h2>
  </div>
  
  <span class="sp_only">
      <span class="sp-title" style="color:blacka;background: #d8e8fc;" v-on:click="Return_login()">
        ← <slot>タイトル</slot>
        <input type="text" class="form-control" v-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
      </span>
    </span>
  <div class="p-2" style="margin-top:0">
    <!-- パンくずリスト -->
    <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb" class="pc_only">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
        </ol>
    </nav>
    <div id="manual_area" style="margin-bottom:10px">

    <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />新規ユーザー登録のマニュアル</span>
    <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>
    <span class="sp_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png" style="height:35px"  /></span>

    </div>
      <br clear="all">

    <!-- ユーザ登録 -->
    <div v-if="mode=='guide'" style="text-align:left">

      <p style="font-size: 1rem;font-weight: bold;color: mediumblue;">新規ユーザー登録を行います。</p>
      <span style="font-size:1.5rem">■</span>アカウントの登録
<!--     
        <div v-html="account_message"></div> 
-->
         <QuillEditor
          class="form-control"
          v-model:content="account_message"
          contentType="html"
          theme="snow"
          readOnly
          :toolbar="[]"
          style="height:auto;margin: 0px;padding: 0px;"
        />

        <div class="sp_only">
        <span style="color: red;font-size:small;font-weight: bold;margin-left:10px;">
          ※ご使用いただけるブラウザは、<br>
          iPhone：Safari / Android：Chorme<br>
          となります。ご了承ください。
        </span>
      </div><br>
      <!-- 家族の登録の有無を設定する。家族の複数登録や切替えが出来るようにする。 -->      
      <div class="family-radio-group" role="radiogroup" aria-label="家族参加" style="text-align:center;">  
        <span style="font-size:1.5rem">■</span><span style="font-weight:bold;">家族（複数人）の登録がありますか？</span><span style="color:red;font-weight:bold;">（必須）</span>
        <span class="sp_only" style="height:0px;"> <br> </span>
        <span>
          <input id="family-yes" class="family-radio-input" type="radio" name="family" value="yes" v-model="selected" v-on:change="joinFamily_check"/>
            <label class="family-radio-btn" for="family-yes" style="width: 80px;text-align: center;">はい</label>&nbsp;
          <input id="family-no" class="family-radio-input" type="radio" name="family" value="no" v-model="selected" v-on:change="joinFamily_check"/>
            <label class="family-radio-btn" for="family-no" style="width: 80px;">いいえ</label>
        </span>
        <span v-if="selected_error" style="color:red;">
            <span class="sp_only" style="height:0px;"> <br> </span>
            &nbsp;{{ selected_error }}
        </span>
      </div><br>

      <div v-if="toroku_flg">

      <!--
        <div class="sp_only" style="color:red;padding-bottom:20px">
          <b>
        ※ 令和7年7月4日：アンドロイドご利用のお客様へ<br>
        一部ブラウザ（Yahooなど）でエラーが発生し、登録ができなくなることが報告されました。恐れ入りますが、ブラウザはChrome（推奨）をご使用下さい。</b>
        </div>
        -->
        <div style="text-align:center;display: flex;justify-content: center;"  >
            <button v-on:click="forward" class="btn btn-primary mx-aut start_button" style="width:100%;max-width:400px;height:45px;">
                メール認証で新規登録
            </button>
        </div>
        
    <div class="bubble-r-line" style="
      margin: 10px 0 5px 0;
      height: 21px;
      display: flex;
      align-items: center;
      justify-content: center;">
        <div class="bubble-r-box" style="height: 9px; left: 26px;width:45% ">
          <div class="bubble-element Shape" style=" box-sizing: border-box;  height: 1px; top: 8px;  left: 0px; background-color: rgb(100, 100, 100); border-radius: 0px; opacity: 1;"></div>
        </div>
        <div class="bubble-r-box" style="height: 21px; left: 196px; width:10%;min-width:100px">
          <div class="bubble-element Text" style="white-space: pre-wrap;  box-sizing: border-box;  top: 0px; width: 100%; left: 0px; height: 21px; overflow: visible; font-family: Lato; font-size: 14px; font-weight: 400; color: rgb(51, 51, 51); text-align: center; line-height: 1; border-radius: 0px; opacity: 1;">
            <div class="content">
              または
            </div>
          </div>
        </div>
        <div class="bubble-r-box" style="height: 9px; left: 217px; width: 45%;">
          <div class="bubble-element Shape" style="box-sizing: border-box;  height: 1px; top: 8px; left: 0px; background-color: rgb(100, 100, 100); border-radius: 0px; opacity: 1;"></div></div></div>
    
    <!--
      <div style="width:100%;text-align:center">※ソーシャルログインは調整中です。</div>
    -->
    <!-- Google -->
    <div  v-on:click="startSocialLogin('Google')"
     style="width:100%; cursor:pointer;
    display: flex;
    justify-content: center;">
    <button class="gsi-material-button" style="width:100%;max-width:400px;height:45px;margin-bottom:10px">
      <div class="gsi-material-button-state"></div>
      <div class="gsi-material-button-content-wrapper">
        <div class="gsi-material-button-icon">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
            <path fill="none" d="M0 0h48v48H0z"></path>
          </svg>
        </div>
        <span class="gsi-material-button-contents">Googleでログイン</span>
        <span style="display: none;">Googleでログイン</span>
      </div>
    </button>
    </div>
    <!-- Apple -->
    <div v-on:click="startSocialLogin('SignInWithApple')" 
     style="width:100%; cursor:pointer;
    display: flex;
    justify-content: center;" v-if="apple_button">
      <button class="bubble-element Button" style="display:flex;align-items: center;margin-bottom:10px;padding: 0px 12px; cursor: inherit; background: none #000000; border: none; text-align: center;  box-sizing: border-box; z-index: 24; height: 45px;width:100%;max-width:400px; top: 0px; left: 1.42109e-14px; font-size: 14px;  color: rgb(255, 255, 255); line-height: 1; border-radius: 5px; opacity: 1;">
        <img  src="../../images/Apple.png" alt="Apple" style="height:28px;padding-right:5px;"/>
        <div class="content" style="width:100%">Appleでログイン</div>
      </button>
    </div>
    <!-- LINE -->
    <div v-on:click="startSocialLogin('LINE')" 
    style="width:100%; cursor:pointer;
    display: flex;
    justify-content: center;" v-if="line_button">
      <button class="bubble-element Button" style="display:flex;align-items: center;margin-bottom:10px;padding: 0px 12px;cursor: inherit; background: none #06C755; border: none; text-align: center;  box-sizing: border-box; z-index: 24; height: 45px;width:100%;max-width:400px; top: 0px; left: 1.42109e-14px; font-size: 14px;  color: rgb(255, 255, 255); line-height: 1; border-radius: 5px; opacity: 1;">
        <img  src="../../images/LINE.png" alt="LINE" style="height:25px;"/>
        <div class="content" style="width:100%">LINEでログイン</div>
      </button>
    </div>
<!--
    <div v-on:click="startSocialLogin()" 
    style="width:100%; cursor:pointer;
    display: flex;
    justify-content: center;" v-if="line_button">
      <button class="bubble-element Button" style="display:flex;align-items: center;margin-bottom:10px;padding: 0px 12px;cursor: inherit; background: none #06C755; border: none; text-align: center;  box-sizing: border-box; z-index: 24; height: 45px;width:100%;max-width:400px; top: 0px; left: 1.42109e-14px; font-size: 14px;  color: rgb(255, 255, 255); line-height: 1; border-radius: 5px; opacity: 1;">
        <div class="content" style="width:100%">LINE・Apple・Googleで新規登録</div>
      </button>
    </div>
-->
    </div>


    </div>
    <div v-if="mode=='select'">
      <div style="text-align:left">
        <h3>ステップ１<br>アカウントの登録を行います。</h3>
        <p><br>以下のいずれかの方法で登録してください。</p>
      </div>
      <div style="width:80%;margin:0 auto">
        <p align="left">Eメールアドレスでの登録</p>
        <button class="btn shadow" v-on:click="toroku('mail')">メールで新規登録する</button><br/><br/><br/>
        
        <!--
        <p align="left">すでに持っている他のアカウントでも登録可能です。</p>
        <button class="btn shadow" v-on:click="toroku('line')">LINEで新規登録する</button><br/><br/>
        <button class="btn shadow" v-on:click="toroku('apple')">Appleで新規登録する</button><br/><br/>
        <button class="btn shadow" v-on:click="toroku('google')">Googleで新規登録する</button><br/><br/>
        <button class="btn shadow" v-on:click="toroku('instagram')">Instagramで新規登録する</button><br/><br/>
        -->
      </div>
    </div>
    <div v-if="mode=='toroku' || mode=='kakunin'">
      <h3 style="text-align: left;font-size: medium !important;">以下を記入し、「登録」ボタンをクリックしてください。</h3>
      <form>
      <!--
      <Form @submit="checkForm" @invalid-submit="InvalidSubmit" v-bind:validation-schema="schema">
        -->
        <table class="vy-search-form-table-nav" id="mailform">
          <tr>
            <th>
              <label for="email">メールアドレス<span style="color:red">（必須）</span></label>
            
              <input name="email" size="50" class="form-control" v-bind:class="{boff:torf}"/>
            </th>
          </tr>
          <tr>
            <th style="padding-bottom:5px">
              <label for="password">パスワード<span style="color:red">（必須）</span></label>
              <input name="password" class="form-control" v-bind:type="passtype" size="50" v-bind:class="{boff:torf}"/>
              <div style="display: flex;padding: 10px 0;align-items: center;"><input type="checkbox" v-model="passvisi" v-on:click="passcont" style="height:20px;width:20px"/>&nbsp;&nbsp;パスワードを表示する</div>
              <span style="color:red">半角英数字、半角記号（- _ $ @ ? / 等）8文字以上。<br>（半角数字は1文字以上、必ず含めてください。）</span>
            
            </th>
          </tr>
          <tr>
            <th>
              <label for="password_verify">パスワードの確認入力<span style="color:red">（必須）</span></label>
            
              <input name="password_verify" class="form-control" v-bind:type="passtype" size="50" v-bind:class="{boff:torf}"/><br/>
            </th>
          </tr>
        </table><br/>
        <input type="button"  v-on:click="deleteSuppression" value="&nbsp;&nbsp;登録&nbsp;&nbsp;" class="btn btn-primary" align="center" style="width:200px;height:50px"/>

        
    </form>
    </div>
    <div v-if="mode=='ninsyo'">
      <p>ご登録いただいたメールアドレスに確認用コードをお送りしましたので、以下に入力して下さい。</p><br/>
      <span style="display: flex;align-items: center;justify-content: center;">確認用コード：<input v-model="ninsyo_no" size="15" style="border-width:2px;"/></span><br/><br/>
      <button class="btn shadow" v-on:click="ninsyo" style="text-align:center;margin-bottom:35px;">確認用コードの照合</button>
      <br/>
      
      <!--
      <span v-on:click="resendCode" style="cursor:pointer;"><u>確認用コードを再送信する</u></span>
      -->
      <div style="color:red;text-align: left;padding:5px">
        <div >【確認用コードが届かない場合】</div>
        メールアドレスをご確認の上、再度「新規ユーザー登録」からお手続してください。<br>
        ※受信拒否や、安心フィルターなどの設定がされている場合は、事前に「{{ GlobalData.$Ninsho_mail }}」からのメールが受信できるように設定してください。

        </div>
      <div v-on:click="Return_toroku" style="cursor:pointer;color:red;font-size: 18px;margin-top:18px"><u><b>新規ユーザー登録に戻る</b></u></div>

    </div>
    <div v-if="mode=='kanryo'" style="text-align:center">
      <h3 style="font-size: medium !important;color: mediumblue;">アカウントの登録が完了しました。</h3><br/>
      <div style="text-align:center"> 
        <input type="button" value="プロフィール登録へ進む" v-on:click="kaiinjoho" style="width:90%;max-width: 250px;height: 50px;" class="btn btn-primary"/><br/><br/>
      </div>
    </div>
  </div>

      
<!--メッセージを表示するモーダルウィンドウ-->
<component v-bind:is="contentMessage"
          v-bind:message_text="message"
          v-bind:message_cat="message_cat"
          v-bind:message_flag="message_flag"
          @close_message="Close_message"
          @ok_message="OK_message"/>
</template>

<script setup>
/* eslint-disable */
import { ref,nextTick  } from 'vue'
import axios from 'axios'
import { useRouter,useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()
const cityname = route.params.shakyo
import { Field, Form, ErrorMessage } from 'vee-validate'
import * as yup from 'yup';
import { GlobalData, login_check } from '../js/userdata.js';
const url = GlobalData.$API_URL
import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails } from 'amazon-cognito-identity-js'
import { signInWithRedirect, signOut } from "aws-amplify/auth";
import AWS from 'aws-sdk'
import useAuth from 'vue-authenticate';
import MessageModal from '../common/MessageModal.vue'
import { useCookies } from 'vue3-cookies'  // 家族の登録が出来るようにするようテーブルに保存するまで家族フラグをcookieに設定する。
const { cookies } = useCookies()

/* メッセージを表示するモーダルウィンドウ */
let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ
/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

let toroku_flg = ref(false)

const emit = defineEmits(['call'])

let mode = ref('guide')
const passvisi = ref(false)
const passtype = ref("password")
const ninsyo_no = ref('')

let selected = ref('')  // 家族設定のラジオボタンの初期値
let selected_error = ref('')

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

let Shakyo_data
let account_message = ref(null)

cookies.set('family', '', '1d');  // 家族設定のラジオボタンのフラグをcookieに設定する　初期値"no"
// 家族設定のラジオボタンのフラグをcookieに設定する
function joinFamily_check() {
    toroku_flg.value = true
    cookies.set('family', selected.value, '1d');
}


const forward = () => {

    if(selected.value == '' || selected.value == undefined){
      selected_error.value = "家族の登録有無の設定は、必須入力です。"
      return
    } else {
      selected_error.value = ""
    }

    mode.value = 'toroku'
//    mode.value = 'select'
    page_scroll()
}

const page_scroll = () =>{
    emit('call', { cmd:'page_scroll' }) 

}

let apple_button = ref(true)
let line_button = ref(true)

let checkin_url = location.hostname


//-------- ログイン方法の選択 ---------------------
const toroku = (sel) => {
    
    emit('call', { cmd:'page_scroll' }) 
    mode.value = 'toroku'
    
}

//-------- 「登録」ボタンの処理 -----------------------
// Amazon SESのサプレッションリストから削除
let suppression_error = 0
let deleteSuppression = function(){ 

    let email = document.forms[0].email.value
    axios.post(url+"SuppressionDelete", 
        {email:email.toString()}
        ).then(response => {
          //  alert("OK")

            checkForm()

    })
    .catch(error => {
      if(suppression_error == 6){
        alert(error + GlobalData.$axios_error)
      }else{
        suppression_error++
        setTimeout(function(){
          deleteSuppression()
        },"1000")
      }
    })
}

const checkForm = () => {

  cookies.remove('provider'); 
    let error_message  = ""

    let email = document.forms[0].email.value
    let password = document.forms[0].password.value
    let password_verify = document.forms[0].password_verify.value

    // メールアドレスが入力されているかどうかの確認      
    let mail_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;//example@mail.comの形式になっているかどうかの確認用
    if(email == ""){
        error_message += "メールアドレスが未入力です。\n"
    }else if (!mail_regex.test(email)) {
        error_message += "メールアドレス以外の値が入力されています。\n"
    }

    // パスワードが入力されているかどうかの確認
    //const pass_regex = /^(?=.*?[A-Z])(?=.*?\d)(?=.*?[!-\/:-@[-`{-~])[!-~]{8,}$/ //8文字以上で、大文字・数字・特殊文字を1文字以上含んでいるかどうかの確認用
    
    const pass_regex = /^(?=.*?\d)[!-~]{8,}$/ //8文字以上で英数字それぞれを1文字以上含んでいるかどうかの確認用
    const num_regex = /^[0-9]*$/// 数字のみかどうかの確認用
    const num_one_regex = /^(?=.*[0-9])[!-~]{8,}$/ // ８文字以上で数字を１文字以上含んでるかどうかの確認用
    if ((password != "" && password_verify != "") && (password != password_verify)) {
        error_message += "パスワードが一致しません。\n" 

    }
    if(password == ""){
        error_message += "パスワードが未入力です。\n"     
    }else if(!num_one_regex.test(password)){
        error_message += "パスワードは8文字以上で数字を1文字以上含んでください。\n"     
    }
    if(password_verify == ""){
        error_message += "パスワード（確認入力）が未入力です。\n"     
    }else if(!num_one_regex.test(password_verify)){
        error_message += "パスワード（確認入力）は8文字以上で数字を1文字以上含んでください。\n"     
    }
    
        // エラーメッセージがあったら処理中断
        if(error_message != ""){
            message.value = error_message;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "validation_error";
            contentMessage.value = MessageModal
            return;
        }

    Signup()  // Cognitoによるサインアップ


}

/*

const redirectUri = location.protocol+"//"+location.host+"/redirect";
console.log(redirectUri)
const scopes = ["openid", "email", "profile", "aws.cognito.signin.user.admin"];

//—- ソーシャルログイン処理 --------------------------------
function startSocialLogin(provider) {
  
  if(selected.value == '' || selected.value == undefined){
    selected_error.value = "家族の登録有無の設定は、必須入力です。"
    return
  } else {
    selected_error.value = ""
  }

  // ソーシャルログイン時、戻る社協英名を保存
  localStorage.setItem('return_shakyo', cityname)
  if(route.params.cmd == "checktaiken" || route.params.cmd == "checkjizen" || route.params.cmd == "checkjigo" ){
    localStorage.setItem('checkin', route.params.cmd)
    localStorage.setItem('checkin_id', route.params.id)
  }
  cookies.remove('provider'); 
  localStorage.setItem('set_provider', provider)

  const url = new URL(`https://${GlobalData.$cognitoDomain}/oauth2/authorize`);
  if (provider != "mail") {
    url.searchParams.set("identity_provider",provider); // プロバイダ名を指定
  }
  url.searchParams.set("response_type", "code"); // 認可コードフロー
  url.searchParams.set("client_id", GlobalData.$social_ClientId);
  url.searchParams.set("redirect_uri", redirectUri);
  url.searchParams.set("scope", scopes.join(" "));
  url.searchParams.set("state", provider);
  window.location.href = url.toString();

}*/
const clientId = GlobalData.$social_ClientId;
const cognitoDomain = GlobalData.$cognitoDomain;
const redirectUri = location.protocol+"//"+location.host+"/redirect";
const scopes = ["openid", "email", "profile", "aws.cognito.signin.user.admin"];
// 1. ソーシャルログイン開始
function startSocialLogin(provider) {
  
  if(selected.value == '' || selected.value == undefined){
    selected_error.value = "家族の登録有無の設定は、必須入力です。"
    return
  } else {
    selected_error.value = ""
  }

  // ソーシャルログイン時、戻る社協英名を保存
  localStorage.setItem('return_shakyo', cityname)
  if(route.params.cmd == "checktaiken" || route.params.cmd == "checkjizen" || route.params.cmd == "checkjigo" ){
    localStorage.setItem('checkin', route.params.cmd)
    localStorage.setItem('checkin_id', route.params.id)
  }
  cookies.remove('provider'); 
  localStorage.setItem('set_provider', provider)


  const url = new URL(`https://${cognitoDomain}/oauth2/authorize`);
  if (provider != "mail") {
    url.searchParams.set("identity_provider",provider); // プロバイダ名を指定
  }
  url.searchParams.set("response_type", "code"); // 認可コードフロー
  url.searchParams.set("client_id", clientId);
  url.searchParams.set("redirect_uri", redirectUri);
  url.searchParams.set("scope", scopes.join(" "));
  url.searchParams.set("state", provider);
  window.location.href = url.toString();
}

//-------- ソーシャルログイン関係 -------- 
// Cognito 設定
const config = {
        region: GlobalData.$Region,
        userPoolId: GlobalData.$UserPoolId,
        userPoolWebClientId: GlobalData.$ClientId,
        identityPoolId: GlobalData.$IdentityPoolId,
        cognitoDomain: GlobalData.$CognitoDomain,
        redirectSignIn: window.location.origin+"/",
        redirectSignOut: window.location.origin+"/",
        responseType: 'code', // 'code' or 'token', token は Implicit Flow で使います
        scope: ['email', 'openid', 'profile']
};



//-------- パスワードの表示／非表示 --------------------
const passcont = () => {
    if (passvisi.value) {
        passtype.value = "password"
    } else {
        passtype.value = "text"
    }
}

/*
const InvalidSubmit = () => {
    message.value ="全ての項目を入力してください。";
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "invalid_error";
    contentMessage.value = MessageModal
}*/


//—- ソーシャルログイン処理 --------------------------------
/*
function startSocialLogin() {

    if(selected.value == '' || selected.value == undefined){
      selected_error.value = "家族の登録有無の設定は、必須入力です。"
      return
    } else {
      selected_error.value = ""
    }

  // ソーシャルログイン時、戻る社協英名を保存
  localStorage.setItem('return_shakyo', cityname)
  if(route.params.cmd == "checktaiken" || route.params.cmd == "checkjizen" ){
    localStorage.setItem('checkin', route.params.cmd)
    localStorage.setItem('checkin_id', route.params.id)
  }
  const url = new URL(`https://${GlobalData.$cognitoDomain}/oauth2/authorize`);
  url.searchParams.set("response_type", "code"); // 認可コードフロー
  url.searchParams.set("client_id", "athmhjnaevim1oel849bvg145");
  url.searchParams.set("redirect_uri", "http://localhost:8080/redirect");
  url.searchParams.set("scope", "openid email profile aws.cognito.signin.user.admin");
  const state = "xyz123"; // CSRF対策用ランダム値
  url.searchParams.set("state", state);
  window.location.href = url.toString();
}
*/
function handleSignIn(set_provider) {

  // ローディングアイコンを表示
  emit('call', { cmd:'social_login'})
  
  // ソーシャルログイン時、戻る社協英名を保存
  localStorage.setItem('return_shakyo', cityname)
  localStorage.setItem('user_signin', route.params.cmd)
  localStorage.setItem('set_provider', set_provider)
  
  if(set_provider == "LINE"){
    try {
      signInWithRedirect({
        provider: { custom: GlobalData.$LINE_text  }, // ‘line’ は、cognitoで指定したプロバイダ名
      });
    } catch (error) {
      console.log('error signing in: ', error);
    }
  }else{
    try {
      signInWithRedirect({
        provider: set_provider,
      });
    } catch (error) {
      console.log('error signing in: ', error);
    }
  }
  
  setTimeout(function(){emit('call', { cmd:'loading_end'})}, "10000");
}

let OK_message = function(){ // メッセージを表示するウィンドウでOKを押された時
    Close_message();//メッセージを表示するウィンドウを閉じる

    if(message_method.value == "return_toroku"){
        mode.value = 'toroku'
        page_scroll()
    }

}

let Close_message = function(){ // メッセージを表示するウィンドウを閉じる
    message_flag.value = false;
    contentMessage.value = null
}

//------------------ AWS Cognito 関連の処理 ---------------------------
const poolData = {
        UserPoolId: GlobalData.$UserPoolId,  // Your user pool id here
        ClientId: GlobalData.$ClientId  // Your client id here
};
// ユーザープールにアクセスする情報をまとめる
const userPool = new CognitoUserPool(poolData);

    var cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
        // ログアウト
        cognitoUser.signOut();
        GlobalData.$User_email = "";
        //alert("ログアウトしました。");
    }

// 属性リスト
let attributeList = [];
let code = ""     //確認用コード
let username = ""
let password = ""
const Signup = function() {// 新規登録するログイン情報を送信する
    
    page_scroll()
    // cognito へユーザ情報をを登録する
    let user_id = ""
    username = document.forms[0].email.value
    password = document.forms[0].password.value
    /*
    attributeList[0] = {
        Name:  "profile",
  
        Value: '{"user_id":null ,"kencd":null ,"city":null ,"kengen":null,"shakyo_code":null }'
    }*/
    //attributeList[1] = {
    //    Name: "address",
    //    Value: kencd + "," + city
    //}
    userPool.signUp(username,password, attributeList, null, function(err, result) {
        if (err) {
            if(err.code == "UsernameExistsException"){
                // 登録済みメールアドレスの場合
                resendConfirmationCode()
                /*
                message.value ="このメールアドレスは既に使われています。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "exists_error";
                contentMessage.value = MessageModal*/
            }else{
                message.value = "コードの送信の回数制限に達しました。1時間ほど置いてお試しください。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "code_error";
                contentMessage.value = MessageModal
            
            }
        }else{
          
            mode.value = "ninsyo"
            //alert("登録に成功しました。")
        }
    });
}

//-------- コードを再送信するを押したとき ----------------
const resendCode = () => {
    
    message.value ="確認用コードを再送信しました。";
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "code_resend";
        contentMessage.value = MessageModal

        resendConfirmationCode()
}
//-------- コードの再送信 ---------------------
const resendConfirmationCode = () => {
    let userData = {
        Username: username, 
        Pool: userPool,
    };
    // cognitoに送信するユーザーデータの作成
    let cognitoUser = new CognitoUser(userData);

    cognitoUser.resendConfirmationCode(function(err, result) {
    console.log("err: ", err);
    console.log("result: ", result);
    if (err) {

        var date = new Date();
        const now_hours = date.getHours(); // 時
        const now_minutes = date.getMinutes(); // 分
        const set_date =  now_hours+"："+now_minutes

        message.value ="確認用コードの送信に失敗しました。\n<span style='color:red'>※同じメールアドレスによる繰り返し送信が検知されました。</span>\n1時間以上の時間をおいて再度登録してください。（"+set_date+"）";
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "code_resend_error";
        contentMessage.value = MessageModal
      return;
    }else{
        
        mode.value = "ninsyo"
    }
  });
}


//-------- 確認用コードのチェック ---------------------
const ninsyo = () => {
    code = ninsyo_no.value
    Verify()
    // login()
   
    
}

const Verify = function() {// メールで送られてきたコードを送信する
    let userData = {
        Username: username,    // 上のsave_user_data()で保存してあったemail
        Pool: userPool,
    };
    // cognitoに送信するユーザーデータの作成
    let cognitoUser = new CognitoUser(userData);
    cognitoUser.confirmRegistration(code, true, function(err, result) {
        if (err) {
            message.value ="認証に失敗しました。確認用コードが一致しないか、登録済みのユーザーの場合があります。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "code_error";
            contentMessage.value = MessageModal
        } else {
            mode.value = "kanryo" 
             loginWithEmail()
        }
    })
}
const loginWithEmail = async () => {
  try {
    const res = await axios.post("/dev/auth_lambda", { email: username, password: password});
    //alert(JSON.stringify(res))
    //alert("メールログイン成功");
    login()
  } catch (err) {
  console.error(err);
    alert("ログインに失敗しました。メールアドレスかパスワードに不備があります。");
  }
};

//-------- 登録したユーザでログインする（ユーザ情報登録のため）
const login = () => {

    // 送信するユーザー名（メールアドレス）とパスワードを配列にする
    let authenticationData = {
        Username: username,    // save_user_data() で保存してあったemail
        Password: password,     // save_user_data() で保存してあったpassword
    };

    const poolData = {
        UserPoolId: GlobalData.$UserPoolId,
        ClientId: GlobalData.$ClientId,
    };
    const userPool = new CognitoUserPool(poolData);
    let userData = {
        Username: username,
        Pool: userPool,
    };

    // 送信するユーザー名（メールアドレス）とパスワードの配列を格納
    let authenticationDetails = new AuthenticationDetails(authenticationData);
    
    let param = 'cognito-idp.ap-northeast-1.amazonaws.com/' + GlobalData.$UserPoolId;
    
    let cognitoUser = new CognitoUser(userData);
    cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function(result) {
            var cognitoUser = userPool.getCurrentUser();
            if (cognitoUser != null) {
                cognitoUser.getSession(function(err, result) {
                    if (result) {
                        // Add the User's Id Token to the Cognito credentials login map.
                        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                            IdentityPoolId: GlobalData.$IdentityPoolId,
                            Logins: {
                                param: result.getIdToken().getJwtToken(),
                            }
                        });
                    }
                });
            }
            login_check()
            //const profile = JSON.parse(GlobalData.$profile);
            //router.push('/User/afterlogin');
            //emit('call', { cmd:'home',id:''})
            // スマホの下メニューの再描画
            setTimeout(function(){emit('call', { cmd:'render_Smart' })},"1500")
        },
        onFailure: function(err) {

        }
    });
}

//---------------- 社協英名から社協ごとの設定を取得
let shakyo_read_error = 0
let shakyo_read = function(){
    axios.post(url+"Shakyo_read", 
        {shakyo:route.params.shakyo}
        ).then(response => {
        Shakyo_data =  response["data"]
        account_message.value = Shakyo_data['account_message']

      })
    .catch(error => {
        
        if(shakyo_read_error == 6){
            alert("社協の設定情報取得に失敗しました。",error);
        }else{
            shakyo_read_error++
            setTimeout(function(){shakyo_read()},"1000")
        }
    })
}

// 社協の設定項目の読み込み
shakyo_read()


//-------- リンク ---------------
const home = function() { router.push('/'+cityname+'/Taiken')  }
const kaiinjoho = () => {
    emit('call', { cmd:'user_toroku' })
}
const kanryo = () => {
    mode.value = "kanryo"
}

let Return_login = function(){
    router.push('/'+cityname+'/Taiken/login')
}

// 新規ユーザー登録へ戻る
let Return_toroku = function(){
   
    ninsyo_no.value = ""//認証コードを初期化

    message.value ="3回以上同じメールアドレスで登録を繰り返すと、15分間、登録できなくなります。";
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "return_toroku";
    contentMessage.value = MessageModal
}
let manual_open = function(){
 
    let url = "https://zest-newsprint-e3e.notion.site/15ec0be34f8f80bfba28f00cd24817b5"
    window.open(url,"_blank")
}

// Q&Aを開く
const qanda_open = () =>{

  let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
  window.open(url,"_blank")
}   

</script>

<style scoped>
table, td {border:none; text-align:left }
p { text-align:left }
button {
     border: 1px solid #000;height:50px;background:#eee;text-align:left 
    }
.boff { border:none;resize:none }

.start_button{
    border:0;width: 200px; height: 50px;padding: 0;background-color:#0066FF;display: flex;align-items: center;justify-content: center;
}

#mailform{
		max-width: 800px;
		margin: auto;
		border: 1px solid #000;
	}
	#mailform tr th{
		padding: 20px;
	}
	#mailform tr td{
		padding-bottom: 25px;
	}
	.checkbox-inline input{
		margin-left: 2px;
		margin-right: 5px;
	}


    ul{
        padding-left: 1.5rem;
    }

    
@media screen and (min-width: 971px) {
    /* PC */
    button{
        width:300px
    }
    
}
@media screen and (max-width: 970px) {
    /* スマホ */
    button{
        width:90%;
        max-width:300px
    }
    
}



.bubble-r-line {
    clear: both;
    pointer-events: none;
  }
  .bubble-r-line .bubble-r-box {
    top: 0;
    pointer-events: none;
}
  /* Googleのログインボタン */
  .gsi-material-button {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -webkit-appearance: none;
    background-color: WHITE;
    background-image: none;
    border: 1px solid #747775;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #1f1f1f;
    cursor: pointer;
    font-family: 'Roboto', arial, sans-serif;
    font-size: 14px;
    height: 40px;
    letter-spacing: 0.25px;
    outline: none;
    overflow: hidden;
    padding: 0 12px;
    text-align: center;
    -webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;
    transition: background-color .218s, border-color .218s, box-shadow .218s;
    vertical-align: middle;
    white-space: nowrap;
    width: auto;
    max-width: 400px;
    min-width: min-content;
  }

  .gsi-material-button .gsi-material-button-icon {
    height: 20px;
    margin-right: 12px;
    min-width: 20px;
    width: 20px;
  }

  .gsi-material-button .gsi-material-button-content-wrapper {
    -webkit-align-items: center;
    align-items: center;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    flex-wrap: nowrap;
    height: 100%;
    justify-content: space-between;
    width: 100%;
  }

  .gsi-material-button .gsi-material-button-contents {
    -webkit-flex-grow: 1;
    flex-grow: 1;
    font-family: 'Roboto', arial, sans-serif;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
  }

  .gsi-material-button .gsi-material-button-state {
    -webkit-transition: opacity .218s;
    transition: opacity .218s;
    bottom: 0;
    left: 0;
    opacity: 0;
    right: 0;
    top: 0;
  }

  .gsi-material-button:disabled {
    cursor: default;
    background-color: #ffffff61;
    border-color: #1f1f1f1f;
  }

  .gsi-material-button:disabled .gsi-material-button-contents {
    opacity: 38%;
  }

  .gsi-material-button:disabled .gsi-material-button-icon {
    opacity: 38%;
  }

  .gsi-material-button:not(:disabled):active .gsi-material-button-state, 
  .gsi-material-button:not(:disabled):focus .gsi-material-button-state {
    background-color: #303030;
    opacity: 12%;
  }

  .gsi-material-button:not(:disabled):hover {
    -webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
    box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
  }

  .gsi-material-button:not(:disabled):hover .gsi-material-button-state {
    background-color: #303030;
    opacity: 8%;
  }
  /* Googleここまで */

/* ラジオボタン用のcss
/* ラジオ本体は画面外に（キーボード/スクリーンリーダー対応のsr-only） */
.family-radio-group {
  gap: 8px;
}

.family-radio-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

/* 通常ボタン見た目 */
.family-radio-btn {
  user-select: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 10px;
  border: 1px solid #c9ced6;
  background: linear-gradient(#f7f9fc, #eef2f7);
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.08),
    inset 0 0 0 rgba(0, 0, 0, 0);
  font-weight: 600;
  transition: box-shadow 0.15s, transform 0.05s, background 0.15s;
}

.family-radio-btn:hover {
  box-shadow:
    0 2px 5px rgba(0, 0, 0, 0.1),
    inset 0 0 0 rgba(0, 0, 0, 0);
}

.family-radio-input:focus-visible + .family-radio-btn {
  outline: 3px solid #7aa9ff;
  outline-offset: 2px;
}

/* 押し込み表現 */
.family-radio-btn:active {
  transform: translateY(1px);
}

/* 選択時（へこんだ見た目） */
#family-yes:checked + .family-radio-btn,
#family-no:checked + .family-radio-btn {
  background: linear-gradient(#e9eef6, #dae3f1);
  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.18);
  border-color: #9fb3cc;
  transform: translateY(1px);
}

/* 念のため：万一ツールバーDOMが出ても非表示 */
:deep(.ql-toolbar) { display: none !important; }
/* 表示専用っぽく枠を消したい場合 */
:deep(.ql-container) { border: none !important; }
</style>
